<template>
  <div class="wrapper">
    <div class="paper df-l-fs" v-if="info.fin">
      
      <!-- 头部 -->
      <section class="w100p">
        <div class="boldbig tac">{{info['companyName'+_lang]}}</div>
        <div class="tac m16">（{{info['shopName'+_lang]}}）</div>
      </section>
      <!-- 信息 -->
      <section class="w100p pb8">
        <div class="df row" v-for="(x,i) in info.bases" :key="i">
          <span class="fsk0">{{$t('report.'+x.key)}}：</span>
          <span class="f1" v-html="x.value||x['value'+_lang]"></span>
        </div>
      </section>
      <!-- 表格 -->
      <section class="w100p">
        <div class="label bold bt pt8">{{$t('report.cashInAndOut')}}</div>
        <table class="w100p">
          <tbody>
            <tr v-for="(x,i) in info.overview" :key="'a'+i">
              <td colspan="1" :class="{'pt8':i===0,'pb8':i===info.overview.length-1}">{{$t('report.'+x.key)}}</td>
              <td colspan="1" :class="{'pt8':i===0,'pb8':i===info.overview.length-1}" class="tar">{{x.value|todoublezero}}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <!-- 表格 -->
      <section class="w100p" v-if="info.cashChangeTypes.length">
        <div class="label bold bt pt8">{{$t('report.detailRecords')}}</div>
        <table class="w100p">
          <thead>
            <tr>
              <th colspan="1" class="pt8 tal">{{$t('report.reason')}}</th>
              <th colspan="1" class="pt8 tac">{{$t('report.time')}}</th>
              <th colspan="1" class="pt8 tar">{{$t('report.amount')}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(x,i) in info.cashChangeTypes">
              <template v-if="x.cash<100000000">
                <tr :key="'b'+i">
                  <td colspan="1" :class="{'pb8':i===info.cashChangeTypes.length-1}" class="tal">{{x['operateReasonName'+_lang]}}</td>
                  <td colspan="1" :class="{'pb8':i===info.cashChangeTypes.length-1}" class="tac">{{x.date}}</td>
                  <td colspan="1" :class="{'pb8':i===info.cashChangeTypes.length-1}" class="tar">{{x.type===1?'':'('}}{{x.cash|todoublezero}}{{x.type===1?'':')'}}</td>
                </tr>
              </template>
              <template v-else>
                <tr :key="'c'+i">
                  <td colspan="1" class="tal">{{x['operateReasonName'+_lang]}}</td>
                  <td colspan="1" class="tac">{{x.date}}</td>
                </tr>
                <tr :key="'d'+i">
                  <td colspan="3" :class="{'pb8':i===info.cashChangeTypes.length-1}" class="tar">{{x.type===1?'':'('}}{{x.cash|todoublezero}}{{x.type===1?'':')'}}</td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </section>

    </div>
  </div>
</template>

<script>
let that
export default {
  name: 'Report2',
  filters: {
    todoublezero: val => {
      if (Number(val||0) >= 0) {
        if (that.sysEnv_x === 'us') {
          val = Number(val||0).toFixed(2)
        } else if (that.sysEnv_x === 'hk') {
          val = Number(val||0).toFixed(1)
        }
      } else {
        if (that.sysEnv_x === 'us') {
          // val = '-' + Number(-val||0).toFixed(2)
          val = '(' + Number(-val||0).toFixed(2) + ')'
        } else if (that.sysEnv_x === 'hk') {
          // val = '-' + Number(-val||0).toFixed(1)
          val = '(' + Number(-val||0).toFixed(1) + ')'
        }
      }
      return String(val).replace(/(\d)(?=(\d{3})+\.)/g, ($0,$1) => $1 + ',').replace(/\.$/, '')
    }
  },
  data() {
    return {
      info: {
        fin: false,
        companyName_zh: '',
        companyName_en: '',
        shopName_zh: '',
        shopName_en: '',
        bases: [
          {key:'address',value_zh:'',value_en:''},
          {key:'phone',value:''},
          {key:'date',value:''},
        ],
        overview: [
          {key:'cashIn',value:0},
          {key:'cashOut',value:0},
          {key:'total',value:0},
        ],
        cashChangeTypes: [],
      }
    }
  },
  methods: {
    getReport() {
      this.$api.cash_report_search({ id: this.currentShopId }).then(res => {
        if (res.status === 0) {
          let _R = res.data
          // console.log(`%c报告:`, 'color: #f00;', _R)

          const {
            companyName,
            shopName_zh,
            shopName_en,
            addressList_zh,
            addressList_en,
            phone,
            date,
            cashManagementList,
            totalCashIn,
            totalCashOut,
            total,
          } = _R

          this.info.companyName_zh = companyName
          this.info.companyName_en = companyName
          this.info.shopName_zh = shopName_zh
          this.info.shopName_en = shopName_en

          if (this.sysEnv_x==='us') {
            const arr_zh = JSON.parse(JSON.stringify(addressList_zh))
            this.info.bases[0].value_zh = arr_zh[0] + '<br/>'
            arr_zh.splice(0, 1)
            this.info.bases[0].value_zh += arr_zh.join(' ')
            const arr_en = JSON.parse(JSON.stringify(addressList_en))
            this.info.bases[0].value_en = arr_en[0] + '<br/>'
            arr_en.splice(0, 1)
            this.info.bases[0].value_en += arr_en.join(' ')
          } else if (this.sysEnv_x==='hk') {
            // this.info.bases[0].value_zh = addressList_zh.join(' ')
            // this.info.bases[0].value_en = addressList_en.join(' ')
            this.info.bases[0].value_zh = addressList_zh[3]
            this.info.bases[0].value_en = addressList_en[3]
          }

          this.info.bases[1].value = phone
          // this.info.bases[2].value = date.replace(/\-/g, '/')
          this.info.bases[2].value = date

          this.info.overview = [
            {key:'cashIn',value:totalCashIn},
            {key:'cashOut',value:-totalCashOut},
            {key:'total',value:total},
          ]
          this.info.cashChangeTypes = cashManagementList.map(x1 => {
            if (x1.reasonId === -1) {
              x1.operateReasonName_zh = x1.operateReasonOther
              x1.operateReasonName_en = x1.operateReasonOther
            }
            x1.date = x1.createDate.substr(5,11)
            return x1
          })

          this.info.fin = true

        } else { this._status(res) }
      })
    },
  },
  created() {
    that = this
  },
}
</script>

<style lang="scss" scoped>
// *{margin: 0;padding: 0;box-sizing: border-box;font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Liberation Sans", "PingFang SC", "Microsoft YaHei", "Hiragino Sans GB", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, SimSun, "WenQuanYi Zen Hei Sharp", sans-serif;}
*{margin: 0;padding: 0;box-sizing: border-box;}
// 1rem = 16px
.wrapper{
  height: 100%;overflow: scroll;flex-shrink: 0;
  .paper{
    width: 30rem;padding: 1rem;background: #fff;overflow: scroll;margin-bottom: 2rem;
    .label{line-height: 25px;}
    
    table{table-layout: fixed;}
    tr, .row{min-height: 24px;line-height: 24px;}
  
    .bt{border-top: 1px dashed #000;}
    .bb{border-bottom: 1px dashed #000;}
  
    .m16{margin: 1rem 0;}
    .mt8{margin-top: 0.5rem;}
    .pt8{padding-top: 0.5rem;}
    .pt16{padding-top: 1rem;}
    .mb8{margin-bottom: 0.5rem;}
    .pb8{padding-bottom: 0.5rem;}
  
    .tac{text-align: center;}
    .tal{text-align: left;}
    .tar{text-align: right;}
    .bold{font-weight: bold;}
    .boldbig{font-size: 1.5rem;font-weight: bold;}
    .line{height: 0;position: relative;top: 0;bottom: 0;margin: auto 1rem;}
  }
}
</style>